/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Mux_LabelInputs */



/**
* | output |
* | --- |
* | "Mux Stream URL or Playback ID" |
*
* @param {Media_Import_Mux_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_mux_label = /** @type {((inputs?: Media_Import_Mux_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Mux_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("URL du flux Mux ou ID de lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mux-Stream-URL oder Playback-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("URL stream Mux o ID di riproduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("URL потока Mux или ID воспроизведения")
	if (locale === "es") return /** @type {LocalizedString} */ ("URL de transmisión de Mux o ID de reproducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Mux 流 URL 或播放 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("MuxストリームURLまたは再生ID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Mux स्ट्रीम URL या प्लेबैक ID")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("URL de stream Mux ou ID de reprodução")
	return /** @type {LocalizedString} */ ("Mux Stream URL or Playback ID")
});